import { Link } from '@material-ui/core'
import React from 'react'
import ReactMarkdown, { ReactMarkdownProps } from 'react-markdown'
import ReactMarkdownWithHtml from 'react-markdown/with-html'

import { Body, H1, H2, H3, H4, H5, H6 } from './typography'

const customHeading = (props: { children: React.ReactNode; level: number }) => {
  const { children, level } = props

  switch (level) {
    case 1:
      return <H1>{children}</H1>
    case 2:
      return <H2>{children}</H2>
    case 3:
      return <H3>{children}</H3>
    case 4:
      return <H4>{children}</H4>
    case 5:
      return <H5>{children}</H5>
    case 6:
      return <H6>{children}</H6>
    default:
      return <Body>{children}</Body>
  }
}

const customLink = (props: { children: React.ReactNode; href: string }) => {
  const { href, children } = props
  return (
    <Link color="inherit" href={href} underline="always">
      {children}
    </Link>
  )
}

const customParagraph = (props: { children: React.ReactElement }) => {
  const { children } = props
  return <Body mb={3}>{children}</Body>
}

const Markdown = ({
  skipHtml = true,
  useHtmlParser = false,
  renderers,
  ...props
}: ReactMarkdownProps & { useHtmlParser?: boolean }) => {
  const MarkdownComponent = useHtmlParser ? ReactMarkdownWithHtml : ReactMarkdown

  return (
    <MarkdownComponent
      {...props}
      renderers={{
        heading: customHeading,
        link: customLink,
        paragraph: customParagraph,
        ...renderers,
      }}
      skipHtml={skipHtml}
    />
  )
}
export default Markdown
